const InProgress = () => {
    return (
        <div className="container mt-5">
            <div className="row">
                <div className="col-12 text-center">
                    <div className="home-wrapper">
                        <div className="mb-5">
                            <a href="index.html" className="d-block auth-logo">
                                <img
                                    src="/img/logo3.png"
                                    alt=""
                                    height={50}
                                    className="auth-logo-dark mx-auto"
                                />
                                <img
                                    src="/img/logo3.png"
                                    alt=""
                                    height={50}
                                    className="auth-logo-light mx-auto"
                                />
                            </a>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-sm-4">
                                <div className="maintenance-img">
                                    <img
                                        src="/assets/images/maintenance.svg"
                                        alt=""
                                        className="img-fluid mx-auto d-block"
                                    />
                                </div>
                            </div>
                        </div>
                        <h3 className="mt-5">This page is currently under development.</h3>
                        <p>Please check back soon for updates.</p>
                        {/* <div className="row">
                            <div className="col-md-4">
                                <div className="card mt-4 maintenance-box">
                                    <div className="card-body">
                                        <i className="bx bx-broadcast mb-4 h1 text-primary" />
                                        <h5 className="font-size-15 text-uppercase">
                                            Why is the Site Down?
                                        </h5>
                                        <p className="text-muted mb-0">
                                            There are many variations of passages of Lorem Ipsum
                                            available, but the majority have suffered alteration.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card mt-4 maintenance-box">
                                    <div className="card-body">
                                        <i className="bx bx-time-five mb-4 h1 text-primary" />
                                        <h5 className="font-size-15 text-uppercase">
                                            What is the Downtime?
                                        </h5>
                                        <p className="text-muted mb-0">
                                            Contrary to popular belief, Lorem Ipsum is not simply random
                                            text. It has roots in a piece of classical.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card mt-4 maintenance-box">
                                    <div className="card-body">
                                        <i className="bx bx-envelope mb-4 h1 text-primary" />
                                        <h5 className="font-size-15 text-uppercase">
                                            Do you need Support?
                                        </h5>
                                        <p className="text-muted mb-0">
                                            If you are going to use a passage of Lorem Ipsum, you need
                                            to be sure there isn't anything embar..{" "}
                                            <a
                                                href="mailto:no-reply@domain.com"
                                                className="text-decoration-underline"
                                            >
                                                no-reply@domain.com
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        {/* end row */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InProgress